import {
  AiOutlineTwitter,
  AiFillGithub,
  AiFillLinkedin,
  AiFillMail,
} from "react-icons/ai";
import Icon from "../../../UI/Icon";
const IconBar = () => {
  return (
    <div>
      <Icon href="https://x.com/BroCode1508">
        <AiOutlineTwitter />
      </Icon>
      <Icon href="https://github.com/abhishekraj15">
        <AiFillGithub />
      </Icon>
      <Icon href="https://www.linkedin.com/in/abhishek-rajput-127887186/">
        <AiFillLinkedin />
      </Icon>

      <Icon href="mailto: rabhi0766@gmail.com">
        <AiFillMail />
      </Icon>
    </div>
  );
};

export default IconBar;
